import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { ProductSpecification } from '@tradecafe/types/core'
import { sortBy } from 'lodash-es'
import { AngularCopy } from 'src/decorators/angular-copy.decorator'
import { AngularParams, HaveAngularParams } from 'src/decorators/angular-params.decorator'
import { environment } from 'src/environments/environment'


const { apiUrl } = environment


@Injectable()
@AngularCopy()
export class ProductSpecificationApiService {
  private http = inject(HttpClient)


  MaxRequestSize = 10000

  @HaveAngularParams()
  list(@AngularParams() params?) {
    return this.http.get<{ data: ProductSpecification[] }>(`${apiUrl}/specifications`, { params }).toPromise().then(({data = []}) => {
      return {
        data: sortBy(data, 'name'),
      }
    })
  }

  create(data: Partial<ProductSpecification>) {
    return this.http.post<{ data: ProductSpecification }>(`${apiUrl}/specifications`, data).toPromise()
  }

  get(id: string) {
    return this.http.get<{ data: ProductSpecification }>(`${apiUrl}/specifications/${id}`).toPromise()
  }

  update(id: string, data: Partial<ProductSpecification>) {
    return this.http.put<{ data: ProductSpecification }>(`${apiUrl}/specifications/${id}`, data).toPromise()
  }
}
